var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.838,
    height: 25.5,
    viewBox: "0 0 28.838 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.088 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.088.75H-.75V-.75H28.088Z",
    transform: "translate(-6.338 12.5)",
    fill: "#f6f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.088.75H-.75V-.75H28.088Z",
    transform: "translate(-6.338 0.5)",
    fill: "#f6f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.088.75H-.75V-.75H28.088Z",
    transform: "translate(-6.338 24.5)",
    fill: "#f6f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.09aeee2e20e76f244d17678a566df98d.svg";
export { ForwardRef as ReactComponent };